import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Injectable()
export class BaseService {
  constructor(private http: HttpClient) {}
  
  getDataLocal() {
    const key = 'credentials'
    return JSON.parse(localStorage.getItem(key)) ? JSON.parse(localStorage.getItem(key)).data : null;
  }

  getDivisionCurrentLocal() {
    const key = 'division'
    return JSON.parse(localStorage.getItem(key));
  }
  getAppCurrentLocal() {
    const key = 'app'
    return JSON.parse(localStorage.getItem(key));
  }

  sp_Login(data: any){
    return this.http.post(environment.serverUrl + '/api/sp_Login2', data)
  }

  sp_Encuesta(data: any){
    return this.http.post(environment.serverUrl + '/api/sp_Encuesta', data);
  }

  add_Personal(data: any){

    console.log("desde servicio add_Personal ",data);

    return this.http.post(environment.serverUrl + '/api/add_Personal', data);
  }

  add_SolicitudPersonal(data: any){

    console.log("desde servicio add_SolicitudPersonal", data);

    return this.http.post(environment.serverUrl + '/api/add_SolicitudPersonal', data);
  }

  add_Solicitud(data: any){
    return this.http.post(environment.serverUrl + '/api/add_Solicitud', data);
  }

  get_RespuestasPregunta(data: any){
    return this.http.post(environment.serverUrl + '/api/get_RespuestasPregunta', data);
  }

  get_PreguntasGrupo(data: any){
    return this.http.post(environment.serverUrl + '/api/get_PreguntasGrupo', data);
  }

  get_PreguntasEncuesta(data: any){
    return this.http.post(environment.serverUrl + '/api/get_PreguntasEncuesta', data);
  }

  get_GUID(data: any){
    return this.http.post(environment.serverUrl + '/api/get_GUID', data);
  }

  get_GruposEncuesta(data: any){
    return this.http.post(environment.serverUrl + '/api/get_GruposEncuesta', data);
  }

  get_Encuesta(data: any){
    return this.http.post(environment.serverUrl + '/api/get_Encuesta', data);
  }

  get_Divisiones(data: any){
    return this.http.post(environment.serverUrl + '/api/get_Divisiones', data);
  }

  get_DatosEncuestado(data: any){
    return this.http.post(environment.serverUrl + '/api/get_DatosEncuestado', data);
  }

  add_VB_Encuesta(data: any){
    return this.http.post(environment.serverUrl + '/api/add_VB_Encuesta', data);
  }

  add_Resultado(data: any){
    return this.http.post(environment.serverUrl + '/api/add_Resultado', data);
  }

  add_DatosEncuestado(data: any){
    return this.http.post(environment.serverUrl + '/api/add_DatosEncuestado', data);
  }

  new_Captcha(){
    return this.http.post(environment.serverUrl + '/auth/new_Captcha', {});
  }

  
  ///
  get_areas(division:any){
   return this.http.post(environment.serverUrl + '/api/get_Areas', {Division:division});
  }

  get_telefonosGerencia(data:any){
    return this.http.post(environment.serverUrl + '/api/get_Areas', data);
  }

  get_empresas(){
    return this.http.post(environment.serverUrl + '/api/get_Empresas', {});
  }

  enviar_email(data: any) {
    return this.http.post(environment.serverUrl + '/api/enviar_email', data);
  }

  get_Personal(idEmpresa: any){
    return this.http.post(environment.serverUrl + '/api/get_Personal', {idEmpresa: idEmpresa});
  }

  get_Solicitudes(data: any){
    return this.http.post(environment.serverUrl + '/api/get_Solicitudes', data);
  }

  get_SolicitudesExcel(data: any){
    return this.http.post(environment.serverUrl + '/api/get_SolicitudesExcel', data);
  }

  get_SolicitudesPersonal(data: any){
    return this.http.post(environment.serverUrl + '/api/get_SolicitudesPersonal', data);
  }

  get_SolicitudesPersona(data: any){
    return this.http.post(environment.serverUrl + '/api/get_SolicitudesPersona', data);
  }

  aprobar_Solicitud(data: any){
    return this.http.post(environment.serverUrl + '/api/set_estado_Solicitud', data);
  }

  set_estado_solicitud_personal(data: any){
    return this.http.post(environment.serverUrl + '/api/set_estado_Solicitud_Personal', data);
  }

  get_EstadoSolicitud(){
    return this.http.post(environment.serverUrl + '/api/get_EstadoSolicitud', {});
  }

  add_QRSolicitudPersona(data){
    return this.http.post(environment.serverUrl + '/api/add_QRSolicitudPersona', data);
  }

  add_QRSolicitud(data){
    return this.http.post(environment.serverUrl + '/api/add_QRSolicitud', data);
  }

  get_NumPendientesSolicitud(data){
    return this.http.post(environment.serverUrl + '/api/get_NumPendientesSolicitud', data);
  }

  get_Actividades(data){
    return this.http.post(environment.serverUrl + '/api/get_Programacion', data);
  }

  get_DetalleXEstado(data){
    return this.http.post(environment.serverUrl + '/api/get_DetalleXEstado', data);
  }
  
  get_AreasUsuario(data){
    return this.http.post(environment.serverUrl + '/api/get_AreasUsuario', data);
  }

  get_LoginAdmin(data){
    return this.http.post(environment.serverUrl + '/api/Login', data);
  }

  set_NuevaClave(data){
    return this.http.post(environment.serverUrl + '/api/cambiarClave', data);
  }

  GetReporteFlash1(data){
    return this.http.post(environment.serverUrl + '/api/GetReporteFlash1', data);
  }

  GetCajasDiagramaOE(data){
    return this.http.post(environment.serverUrl + '/api/GetCajasDiagramaOE', data);
  }

  GetMantencionesProgramadas(data){
    return this.http.post(environment.serverUrl + '/api/GetMantencionesProgramadas', data);
  }
  
  get_Portada(data){
    return this.http.post(environment.serverUrl + '/api/get_Portada', data);
  }

  add_Portada(data){
    return this.http.post(environment.serverUrl + '/api/add_Portada', data);
  }

  getEspesadores(data){
    return this.http.post(environment.serverUrl + '/api/GetEspesadoresInstantaneo', data);
  }

  GetMetricasDia(data){
    return this.http.post(environment.serverUrl + '/api/GetMetricasDia', data);
  }

  get_Programa(data){
    return this.http.post(environment.serverUrl + '/api/get_Programa', data);
  }

  set_ProgramacionEstado(data){
    return this.http.post(environment.serverUrl + '/api/set_ProgramacionEstado', data);
  }

  add_ProdLog(data){
    return this.http.post(environment.serverUrl + '/api/add_ProdLog', data);
  }

  get_Comentarios(data){
    return this.http.post(environment.serverUrl + '/api/get_Comentarios', data);
  }
  
  get_Bitacora(data){
    return this.http.post(environment.serverUrl + '/api/get_Bitacora', data);
  }

  get_Turno(data){
    return this.http.post(environment.serverUrl + '/api/get_Turno', data);
  }

  get_Tareas(data){
    return this.http.post(environment.serverUrl + '/api/get_Tareas', data);
  }

  get_empresas_en_area(data){
    return this.http.post(environment.serverUrl + '/api/get_empresas_en_area', data);
  }

  add_TareasSolicitud(data){
    return this.http.post(environment.serverUrl + '/api/add_TareasSolicitud', data);
  }

  set_estados_solicitudes_personales(data: any){
    return this.http.post(environment.serverUrl + '/api/set_estados_solicitudes_personales', data);
  }

  set_emails_estado_solicitudes(data: any) {
    return this.http.post(environment.serverUrl + '/api/enviar_emails', data);
  }

  aprobar_solicitud_global(data: any){
    return this.http.post(environment.serverUrl + '/api/aprobar_solicitud_global', data);
  }

}
